import useAttendanceAction from './vm';
import ReuseIcon from '../../../../../../icons/ReuseIcon';
import Button from '../../../../../../components/Button';
import Tooltip from '../../../../../../components/Tooltip';
import { useTranslation } from 'react-i18next';
import { i18nNS } from '../../../../../../i18n';
import { AttendancePageScreens } from '../../types';

const AttendanceAction = () => {
  const { t } = useTranslation([i18nNS.CLASS]);
  const { currentScreen, handleClickReuseAttendance } = useAttendanceAction();

  if (currentScreen !== AttendancePageScreens.ATTENDANCE_RECORDED) return;

  return (
    <Tooltip title={t('reset_attendance', { ns: i18nNS.CLASS })}>
      <Button variant="text" size="small" onClick={handleClickReuseAttendance}>
        <ReuseIcon size={20} aria-hidden />
      </Button>
    </Tooltip>
  );
};

export default AttendanceAction;
